// src/App.jsx
import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import ApplicationForm from './components/ApplicationForm';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin, { isAuthenticated } from './components/AdminLogin';
import { isFormClosed } from './lib/config';
import './styles/global.css';

// ── Obrazovka po uzávěrce sběru přihlášek ─────────────────────
// Renderuje se místo ApplicationForm, takže se nezakládají ani
// nové drafty (registrace session běží až při mountu formuláře).
function FormClosed() {
  return (
    <div style={{
      maxWidth: 560, margin: '0 auto', padding: '0 24px', textAlign: 'center',
      minHeight: 'calc(100vh - 56px - 88px)',
      display: 'flex', flexDirection: 'column', justifyContent: 'center',
    }}>
      <div style={{
        width: 80, height: 80,
        background: 'rgba(91,20,179,0.08)', border: '2px solid #5b14b3',
        borderRadius: '50%', display: 'flex', alignItems: 'center',
        justifyContent: 'center', fontSize: 32, margin: '0 auto 24px',
      }}>🔒</div>
      <h2 style={{ fontFamily: 'GT Super Display, serif', fontSize: 32, marginBottom: 12 }}>
        Sběr přihlášek byl uzavřen
      </h2>
      <p style={{ color: '#888', lineHeight: 1.7, marginBottom: 8 }}>
        Přihlášky do programu <strong>Founder Stipendium</strong> bylo možné
        podávat do <strong>16.&nbsp;8.&nbsp;2026 do&nbsp;23:59</strong>.
        Děkujeme všem, kteří se přihlásili!
      </p>
      <p style={{ color: '#888', lineHeight: 1.7 }}>
        Máte-li dotaz, napište nám na{' '}
        <a href="mailto:hadasova@jic.cz" style={{ color: '#5b14b3', fontWeight: 600 }}>
          hadasova@jic.cz
        </a>.
      </p>
      <div style={{ marginTop: 32 }}>
        <a
          href="https://www.jic.cz/cz/Sluzby/future-founders/founder-stipendium"
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-block',
            background: '#5b14b3', color: '#fff', borderRadius: 8,
            padding: '12px 28px', textDecoration: 'none', fontWeight: 600, fontSize: 14,
          }}
        >
          Více o Founder Stipendiu →
        </a>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <footer style={{ background: '#5b14b3' }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        padding: '28px clamp(24px, 4vw, 60px)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 16, flexWrap: 'wrap',
      }}>
        <a
          href="https://www.jic.cz/cz/Sluzby/future-founders/founder-stipendium"
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-block',
            background: 'rgba(254,216,117,0.15)',
            color: '#fed875',
            borderRadius: 6,
            padding: '6px 14px',
            textDecoration: 'none',
            fontWeight: 600,
            fontSize: 12,
            border: '1px solid rgba(254,216,117,0.4)',
          }}
        >
          Founder Stipendium →
        </a>
        <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)' }}>
          © 2026 JIC
        </span>
      </div>
    </footer>
  );
}

function getView() {
  return window.location.hash === '#admin' ? 'admin' : 'form';
}

export default function App() {
  const [view, setView]         = useState(getView);
  const [authed, setAuthed]     = useState(isAuthenticated);

  useEffect(() => {
    const onHash = () => setView(getView());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main style={{ flex: 1 }}>
        {view === 'form' && (isFormClosed() ? <FormClosed /> : <ApplicationForm />)}
        {view === 'admin' && (
          authed
            ? <AdminDashboard />
            : <AdminLogin onLogin={() => setAuthed(true)} />
        )}
      </main>
      <Footer />
    </div>
  );
}
